import { h, Component, Prop, State, Element } from '@stencil/core';

@Component({
  shadow: false,
  styleUrls: {
    default: 'igws-notice-strip.less',
    rtl: 'igws-notice-strip.less',
    rebrand: './rebrand/igws-notice-strip.less',
    rtl_rebrand: './rebrand/igws-notice-strip.less',
    prime: './prime/igws-notice-strip.less',
    rtl_prime: './prime/igws-notice-strip.less',
    investments: 'igws-notice-strip.less',
    rtl_investments: 'igws-notice-strip.less',
    helpandsupport: 'igws-notice-strip.less',
    rtl_helpandsupport: 'igws-notice-strip.less',
    academy: 'igws-notice-strip.less',
    rtl_academy: 'igws-notice-strip.less',
    landingpages: 'igws-notice-strip.less',
    rtl_landingpages: 'igws-notice-strip.less',
    generic: './prime/igws-notice-strip.less',
    rtl_generic: './prime/igws-notice-strip.less',
  },
  tag: 'igws-notice-strip',
})
export class NoticeStripComponent {
  marginBottom = 40;
  minBoxHeight = 0;

  @Element() el!: HTMLIgwsNoticeStripElement;

  @State() toggle: boolean = false;

  /**
   * Text to display on the notice strip
   */
  @Prop() text!: string;

  @Prop() ismulticomponent: boolean = false;

  checkMinHeight(height) {
    let returnHeight;
    if (this.minBoxHeight === 0) {
      returnHeight = height;
    } else if (height < this.minBoxHeight) {
      returnHeight = height;
    } else {
      returnHeight = this.minBoxHeight;
    }
    return returnHeight;
  }
  update_item_opacity(selector, status: string, hoverElement: HTMLElement) {
    const elements = hoverElement.querySelectorAll<HTMLElement>(selector);
    if (elements) {
      elements.forEach(element => {
        if (status === 'visible') {
          element.style.opacity = '1';
        } else {
          element.style.opacity = '0';
        }
      });
    }
  }
  collapseSection(element) {
    const elH3 = element.querySelector('h3').scrollHeight + this.marginBottom;
    element.style.bottom = -Math.abs(element.scrollHeight - elH3) + 'px';
    this.update_item_opacity('.simple-text p', 'hidden', element);
    element.querySelector('.cta.section').style.opacity = 0;
  }
  expandSection(element) {
    element.style.bottom = 0;
    this.update_item_opacity('.simple-text p', 'visible', element);
    element.querySelector('.cta.section').style.opacity = 1;
  }
  setupMultiPromoScript() {
    const marginBottom = 40;
    let minBoxHeight = 0;
    const els = document.querySelectorAll<HTMLElement>('.multipromo-col');
    els.forEach(element => {
      minBoxHeight = this.checkMinHeight(element.scrollHeight);
      element.classList.add('op-textAnimation');
      const boxHeader = element.querySelector('h3');
      const textBox = element.querySelector<HTMLElement>('.multipromo-col__text-box > div');
      if (boxHeader && textBox) {
        const elH3Height = boxHeader.scrollHeight + marginBottom;
        textBox.classList.add('op-inText');
        textBox.style.bottom = -Math.abs(minBoxHeight - elH3Height) + 'px';
        element.addEventListener('mouseover', () => {
          this.expandSection(textBox);
        });
        element.addEventListener('mouseout', () => {
          this.collapseSection(textBox);
        });
        minBoxHeight = minBoxHeight < 300 ? 300 : minBoxHeight;
        if (!element.classList.contains('op-textAnimationFinished')) {
          element.style.minHeight = `${minBoxHeight}px`;
          element.classList.add('op-textAnimationFinished');
        }
      }
    });
  }

  toggleClick() {
    this.toggle = !this.toggle;
  }

  render() {
    let extraClass = 'notice-strip__wrapper--standard';
    if (this.ismulticomponent) {
      extraClass = 'notice-strip__wrapper--multi';
      this.setupMultiPromoScript();
    }
    return (
      <div class={`notice-strip__wrapper ${this.toggle ? 'expanded' : ''} ${extraClass}`}>
        <div class="banner-area">
          <slot />
        </div>
        <button onClick={() => this.toggleClick()} class="notice-strip">
          <span>{this.text}</span>
        </button>
      </div>
    );
  }
}
